import { ApiClientError } from '@/api/client';

const localizedStatusMessages: Record<number, string> = {
  400: '請求內容有誤，請檢查後再試。',
  401: '登入狀態已失效，請重新登入。',
  403: '你目前沒有存取此資料的權限。',
  404: '找不到所請求的資料。',
  409: '資料狀態已變更，請重新載入後再試。',
  422: '輸入內容未通過驗證，請檢查後再試。',
  429: '操作過於頻繁，請稍後再試。',
};

const localizedCodeMessages: Record<string, string> = {
  AUTH_TURNSTILE_REQUIRED: '請完成人機安全驗證。',
  AUTH_TURNSTILE_INVALID: '安全驗證失敗，請重新驗證後再試。',
  AUTH_TURNSTILE_HOSTNAME_INVALID: '安全驗證來源不符，請重新整理頁面後再試。',
  AUTH_TURNSTILE_ACTION_INVALID: '安全驗證用途不符，請重新整理頁面後再試。',
};

const containsCjkText = (value: string) => /[\u3400-\u9fff]/u.test(value);

export function getUserFacingErrorMessage(error: unknown, fallback = '暫時無法完成操作，請稍後再試。') {
  if (error instanceof ApiClientError) {
    if (localizedCodeMessages[error.error.code]) return localizedCodeMessages[error.error.code];
    if (localizedStatusMessages[error.status]) return localizedStatusMessages[error.status];
    if (error.status === 0) return '網路連線失敗，請確認連線後再試。';
    if (error.status >= 500) return '服務暫時無法使用，請稍後再試。';
    return fallback;
  }

  if (error instanceof Error && containsCjkText(error.message)) return error.message;
  return fallback;
}

export function getApiErrorDescription(error: unknown) {
  const message = getUserFacingErrorMessage(error, '發生未預期的錯誤，請稍後再試。');
  const requestId = error instanceof ApiClientError ? error.requestId : undefined;
  return requestId && requestId !== 'unknown' ? `${message} 請求識別碼：${requestId}` : message;
}
